import * as React from "react"
import { Calendar } from "@/components/ui/calendar"

export function DateRangePicker({ value, onChange }) {
  const [date, setDate] = React.useState(value)

  const handleSelect = (newDate) => {
    setDate(newDate)
    if (onChange) {
      onChange(newDate)
    }
  }

  return (
    <Calendar
      mode="range"
      selected={date}
      onSelect={handleSelect}
      numberOfMonths={2}
      className="rounded-md border"
    />
  )
}
